/**
 * Shared utility helpers for the Welcome / Projects feature.
 */

/**
 * Bare-minimum shape check for a flow object.
 * Returns true when objB has at least 'Title' and 'flow_id'.
 */
export const isObjectEqual = objB => {
    if (typeof objB !== 'object' || objB === null) {
        return false
    }
    const requiredKeys = ['Title', 'flow_id']
    return requiredKeys.every(key => objB.hasOwnProperty(key))
}

/**
 * Get the correct payment product ID for the current environment.
 * Works for both group objects (reads payment_ids directly) and
 * flow items (looks up flowGroups[item.group_id].payment_ids[env]).
 * Falls back to legacy item.spid.
 */
export const getPaymentProductId = (item, flowGroups) => {
    const env = window.NODE_ENV || '';
    if (!item) return null;
    // If item IS a group (has payment_ids directly)
    if (item.payment_ids && item.payment_ids[env]) {
        return item.payment_ids[env];
    }
    // If item is a flow item, lookup group via group_id
    const groupKey = item.group_id;
    if (groupKey && flowGroups && flowGroups[groupKey]) {
        const group = flowGroups[groupKey];
        if (group.payment_ids && group.payment_ids[env]) {
            return group.payment_ids[env];
        }
    }
    // Fallback to legacy spid
    return item.spid || null;
};
